import styled from '@emotion/styled';

import { ButtonBase } from 'components/buttons/ButtonBase';

export const ButtonTertiary = styled(ButtonBase)`
  position: relative;
  padding: 6px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background-color: #fff;
  font-family: ${({ theme }) => theme.fonts.default};
  font-size: 14px;
  font-weight: 400;

  &,
  &.MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.colors.tertiary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tertiary};
    border-color: ${({ theme }) => theme.colors.tertiary};
    color: #fff;
  }
`;
